import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Table,
  Divider,
  Popconfirm,
  Col,
  Row,
  Steps,
  Button,
  message,
  Typography,
  Tag
} from "antd";
import moment from "moment";
import "../index.less";
import { DownloadOutlined } from "@ant-design/icons";
import { baseUrl, platformApi } from "../../../../api";
import TrackSpareOrderModal from "./TrackSpareOrderModal";
import vehicleLogo from "../../../../assets/vehiclelogo.png";
import { callContext } from "../../../../App";
import { piopiy, piopiyDialUser } from "../../../../utils/piopiy";
import { ContextAPI } from "../../../../ContextAPI";
import VehicleName from "../../../VehicleName";
import WrappedFeedbackCallModal from "./FeedbackCallModal"
import PaymentModal from "../../../paymentModal";
import LedgerModal from "../../Ledger/LedgerModal";
import ClaimIntimationModal from "../JobOrderModal/ClaimIntimationModal";
import FinalInspectionModal from "../JobOrderModal/FinalInspectionModal";
import GatePassOtpModal from "../JobOrderModal/GatePassOtpModal";
import JobCardSectionsModal from "../JobCardSections/JobCardSectionsModal";
import WorkInProgress from "../WorkInProgress";
const { Step } = Steps;
const { Text } = Typography;
const JobOrderTable = (props) => {
  const history = useHistory();
  const { mobileNumber, setMobileNumber } = useContext(callContext);
  const telecmiUser = localStorage.getItem('selectedTelecmiUserId');
  const [paymentModal, setPaymentModal] = useState(false);
  const [whatsappAccess, setWhatsappAccess] = useState(false);
  const [callAccess, setCallAccess] = useState(false);
  const [spareAccess, setSpareAccess] = useState(false);
  const [materialIssueAccess, setMaterialIssueAccess] = useState(false);
  const [labourPerformAccess, setLabourPerformAccess] = useState(false);
  const [labourPerformReadAccess, setLabourPerformReadAccess] = useState(false);
  const [estimateAccess, setEstimateAccess] = useState(false);

  useEffect(() => {
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess?.map((each) => {
        if (each.subModule === "whatsapp_web" && each.access.create) {
          setWhatsappAccess(true);
        }
        if (each.subModule === "telecmi" && (each.access.create || each.access.read)) {
          setCallAccess(true);
        }
        if (each.subModule === "customer_spare_order" && each.access.create) {
          setSpareAccess(true);
        }
        if (each.subModule === "material_issue" && each.access.create) {
          setMaterialIssueAccess(true);
        }
        if (each.subModule === "labour_perform") {
          if (each.access.create) setLabourPerformAccess(true);
          if (each.access.read || each.access.create) setLabourPerformReadAccess(true);
        }
        if (each.subModule === "estimate" && each.access.create) {
          setEstimateAccess(true);
        }
      });
  }, [loginCredintials])

  const {
    pagination,
    dataSource,
    openModal,
    spinner,
    modify,
    setAssign,
    setAssignData,
    setLogData,
    setLog,
    setInsp,
    setStatusData,
    setOtpData,
    setOtp,
    setReferenceId,
    gst,
    deleteAccess,
    printAccess,
  } = props;

  const { loginCredintials } = useContext(ContextAPI);
  const [orderspareModal, setOrderspareModal] = useState(false);
  const [selectedid, setSelectedid] = useState("");
  const [selectedData, setSelectedData] = useState();
  const [pymidolLoading, setPymidolLoading] = useState({});
  const [resendSmsLoading, setResendSmsLoading] = useState({});

  const [feedbackCallOpen, setFeedbackCallOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerLedgerOpen, setCustomerLedgerOpen] = useState(false);

  const [claimModalOpen, setClaimModalOpen] = useState(false);
  const [selectedJobForClaim, setSelectedJobForClaim] = useState(null);
  const [finalInspectionModalOpen, setFinalInspectionModalOpen] = useState(false);
  const [selectedJobForInspection, setSelectedJobForInspection] = useState(null);
  const [gatePassModalOpen, setGatePassModalOpen] = useState(false);
  const [selectedJobForGatePass, setSelectedJobForGatePass] = useState(null);
  const [sectionsModalOpen, setSectionsModalOpen] = useState(false);
  const [selectedJobForSections, setSelectedJobForSections] = useState(null);

  const handleStartWork = async (jobId) => {
    try {
      const res = await platformApi.post(`/api/jobOrder/startWork/${jobId}`);
      if (res?.data?.code === 200 || res?.status === 200) {
        message.success("Work started! Job moved to Work In Progress.");
        if (props.onTabSwitch) {
          props.onTabSwitch("4");
        } else if (props.setPageData) {
          props.setPageData(null, "Work In Progress");
        } else if (props.onPageChange) {
          props.onPageChange(props.page || 1);
        }
      } else {
        message.error(res?.data?.message || "Failed to start work");
      }
    } catch (err) {
      console.error("Error starting work", err);
      message.error("Failed to start work");
    }
  };

  const hasCashCollectAccess = () => {
    if (
      loginCredintials?.roleAccess
    ) {
      return loginCredintials.roleAccess.some(
        (acc) =>
          acc.master === "TRANSACTIONMASTER" &&
          (acc.subModule === "Cash Payment" || acc.subModule == "POS Machine") &&
          acc.access.create === true
      );
    }
    return false;
  };

  const [pdf, setPdf] = useState(null);
  const checkStatus = (jobStatus) => {
    let status = "0";
    switch (jobStatus) {
      case "Vehicle Received":
        status = "0";
        break;
      case "Estimation":
        status = "0";
        break;
      case "Estimation Approved":
        status = "0";
        break;
      case "Mechanic Allocated":
      case "Spares Ordered":
      case "Spares Partially Ordered":
      case "Spare Received":
      case "Material Issued":
      case "Parts Issued":
      case "Labour Performed":
        status = "1";
        break;
      case "Work In Progress":
      case "Washing":
      case "Washing and Final Inspection":
      case "Final Inspection":
      case "Proforma Invoice":
      case "Work Completed":
        status = "1";
        break;
      case "Payment Completed":
      case "Ready for Delivery":
      case "Invoice":
      case "PAID":
      case "Payment Received":
      case "Gate Pass":
      case "Delivered":
        status = "2";
        break;
      default:
        status = "0";
        break;
    }
    return status;
  };

  const handleCall = (jobdata) => {
    if (!telecmiUser) {
      message.error("Can't place call, Login to telecmi account to continue");
      return;
    }

    if (!(jobdata?.customerPhone && jobdata?.id)) return;
    const jobData = {
      jobOrder: jobdata.id,
      event: "Outgoing Call",
    };

    platformApi.post("/api/jobOrderlog", jobData).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        const uuid = response?.data?.id;
        let mobileNumber = "91" + jobdata.customer?.contacts?.[0]?.phone;
        setMobileNumber(mobileNumber);
        piopiyDialUser(piopiy, mobileNumber, uuid, "Job-Order", jobdata.id);
      }
    });
  };

  const handlePushToPymidol = async (jobCardId) => {
    console.log('Push to Pymidol clicked for jobCardId:', jobCardId);
    setPymidolLoading(prev => ({ ...prev, [jobCardId]: true }));

    try {
      const response = await platformApi.post('/api/pymidol/push', {
        jobCardId: jobCardId
      });

      if (response.data.code === 200) {
        message.success({
          content: 'Automation triggered successfully',
          duration: 3,
          className: 'success-notification'
        });
      } else {
        message.error(response.data.message || 'Failed to trigger automation');
      }
    } catch (error) {
      console.error('Error pushing to Pymidol:', error);
      message.error('Failed to trigger automation');
    } finally {
      setPymidolLoading(prev => ({ ...prev, [jobCardId]: false }));
    }
  };

  const sendSms = async (data, type) => {
    let value = {
      phone: data.customer?.contacts?.[0]?.phone,
      id: data.id,
      customerId: data.customer?.id,
      cname: data.customer?.name,
      jcid: data.jobNo,
      vname: data.vehicle?.vehicle?.modelName || "N/A",
      vno: data.vehicle?.registerNo || "N/A",
      srty: data.serviceType,
      type: type,
    };

    if (type === "SMS") {
      await platformApi
        .post("api/jobOrder/sms", value)
        .then((res) => {
          let { data } = res;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              message.success("Message Send Successfully");
            } else {
              message.error("Failed to Sms Send");
            }
          } else {
            message.error("Failed to Sms Send");
          }
        })
        .catch((error) => {
          console.error("Failed to Sms Send: ", error);
          message.error("Failed to Sms Send");
        });
    } else if (type === "WhatsApp") {
      await platformApi
        .post("api/jobOrder/sms", value)
        .then((res) => {
          let { data } = res;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              message.success("WhatsApp Message Send Successfully");
            } else {
              message.error("Failed to WhatsApp Message Send");
            }
          } else if (data.code === 400) {
            message.error(data.message);
          } else if (data.code === 401) {
            message.error(data.message);
          } else {
            message.error("Failed to WhatsApp Message Send");
          }
        })
        .catch((error) => {
          console.error("Failed to WhatsApp Message Send: ", error);
          message.error("Failed to WhatsApp Message Send");
        });
    }
  };

  const resendJobCardSms = async (data) => {
    setResendSmsLoading(prev => ({ ...prev, [data.id]: true }));
    try {
      await sendSms(data, "WhatsApp");
    } finally {
      setResendSmsLoading(prev => ({ ...prev, [data.id]: false }));
    }
  };

  const sendEstOtp = async (data) => {

    platformApi
      .post("/api/JobOrder/sendOtp", {
        phone: data.customer?.contacts?.[0].phone,
        type: "WhatsApp",
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            const { data } = response;
            const { referenceId } = data;
            setReferenceId(referenceId);
            message.success("OTP is sent to your registered number", 5);
            setOtp(true);
          } else {
            message.error("Unable to send OTP", 2);
          }
        } else if (data.code === 400) {
          message.error(data.message);
        } else if (data.code === 401) {
          message.error(data.message);
        } else {
          message.error("Unable to send OTP", 2);
        }
      })
      .catch((e) => {
        message.error("Unable to send OTP", 2);
      });
  };

  const pdfGenerate = async (data) => {
    await platformApi.post("api/jobOrder/pdfGenerate", data).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setPdf(response.pdfWithoutBrochure.data.Location);
          message.success("PDF Generated Successfully");
        } else {
          message.error("Failed to PDF Generated");
        }
      } else {
        message.error("Failed to PDF Generated");
      }
    });
  };

  const handleDownloadPDF = (data, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    // PDF is always generated fresh on-demand by the backend endpoint.
    // No S3 redirect, no polling — just open the stream URL in a new tab.
    window.open(`${baseUrl}api/jobOrder/generatePDF/${data.id}`, "_blank");
  };

  const handleDownloadAdditionalSheets = (data, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    window.open(`${baseUrl}api/jobOrder/additionalSheetsPDF/${data.id}`, "_blank");
  };
  const column = [
    {
      // title: "Action",
      render: (data) => {
        const createdDate = moment(data.createdAt).startOf('day');
        const today = moment().startOf('day');
        const isCompleted = data.jobStatus === "PAID";
        const endDate = isCompleted && data.updatedAt ? moment(data.updatedAt).startOf('day') : today;
        const countDays = (data.vehicleStaysDays !== null && data.vehicleStaysDays !== undefined)
          ? data.vehicleStaysDays
          : endDate.diff(createdDate, 'days');
        const expectedDelivery = data.expectedDeliveryDate
          ? moment(data.expectedDeliveryDate).startOf('day')
          : (data.createdAt
            ? moment.utc(data.createdAt).utcOffset("+05:30").startOf('day').add(1, 'weeks')
            : null);
        const isPending = checkStatus(data.jobStatus) === "0";
        const isOverdue = expectedDelivery && today.isAfter(expectedDelivery) && isPending;
        return (
          <div
            className="box"
            style={{
              position: "relative",
              padding: "20px",
              backgroundColor: "white",
              border: isOverdue ? "2px solid #ff4d4f" : "2px solid transparent",
              boxShadow: isOverdue ? "0px 0px 10px 2px rgba(255, 77, 79, 0.6)" : undefined
            }}
          >
            <div
              style={{
                position: "absolute",
                top: "20px",
                left: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                width: "42px",
                height: "42px",
                backgroundColor: "#0d9488",
                color: "white",
                fontWeight: "bold",
                fontSize: "18px",
                zIndex: 2,
              }}
              title="Service Duration"
            >
              {countDays}
            </div>
            <Row type="flex" align="middle">
              <Col
                span={6}
                style={{
                  borderRight: "0.1px solid rgba(0, 0, 0, 0.1)",
                  padding: "1rem 1rem 1rem 3.5rem",
                }}
              >
                <table>
                  <thead>
                    <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Job No
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        {data.jobNo && data.jobNo}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Reg. No
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        {data.vehicle && data.vehicle.registerNo}
                      </td>
                    </tr>
                    {data.serviceType == "PDI" && <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Battery No
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        {data.vehicle && data.vehicle.batteryNo}
                      </td>
                    </tr>}
                    <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Customer
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        <span
                          className="linkylink"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (data.customer) {
                              setSelectedCustomer(data.customer);
                              setCustomerLedgerOpen(true);
                            }
                          }}
                        >
                          {data.customer?.name || "-"}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right", fontWeight: "bolder" }}>
                        Model
                      </td>
                      <td>:</td>
                      <td style={{ textAlign: "left", paddingLeft: ".5rem" }}>
                        {data.vehicle?.vehicle ? (
                          <VehicleName nameOnly value={data.vehicle.vehicle} />
                        ) : null}
                      </td>
                    </tr>
                    {data.vehicle?.insuranceExpiryDate &&
                      (() => {
                        const expiryDate = moment(
                          data.vehicle.insuranceExpiryDate
                        );
                        const today = moment();
                        const daysLeft = expiryDate.diff(today, "days");
                        const formattedDate = expiryDate.format("DD-MM-YYYY");

                        const isExpiringSoon = daysLeft >= 0 && daysLeft <= 30;

                        return (
                          <tr
                            style={
                              isExpiringSoon ? { color: "red", fontWeight: "bold" } : {}
                            }
                          >
                            <td
                              style={{
                                textAlign: "right",
                                fontWeight: "bolder",
                              }}
                            >
                              Insurance Renewal On
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              <span>
                                {formattedDate}
                              </span>
                            </td>
                          </tr>
                        );
                      })()}
                  </thead>
                </table>
              </Col>
              <Col
                span={4}
                style={{
                  padding: "1rem",
                }}
              >
                <div>
                  <img
                    style={{ width: "150px", height: "120px" }}
                    src={
                      data.vehicle?.color && data.vehicle.color
                        ? data.vehicle.color.url
                        : vehicleLogo
                    }
                  />
                </div>
              </Col>
              <Col span={14}>
                <div style={{ margin: "1rem" }}>
                  <Row>
                    <Col span={10}>
                      <table>
                        <thead>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Service Type
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.serviceType && data.serviceType}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Mechanic
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.mechanic
                                ? data.mechanic.profile.employeeName
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Supervisor
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.supervisor ? data.supervisor.name : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Service Number
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.serviceNo ? data.serviceNo : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{ textAlign: "right", fontWeight: "bolder" }}
                            >
                              Kms
                            </td>
                            <td>:</td>
                            <td
                              style={{ textAlign: "left", paddingLeft: ".5rem" }}
                            >
                              {data.kms ? data.kms : "-"}
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </Col>
                    <Col span={14}>
                      <Row>
                        <Col span={12}>
                          <table>
                            <thead>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bolder",
                                  }}
                                >
                                  Date
                                </td>
                                <td>:</td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    paddingLeft: ".5rem",
                                  }}
                                >
                                  {data.createdAt &&
                                    moment.utc(data.createdAt).utcOffset("+05:30").format(
                                      "DD-MM-YYYY"
                                    )}
                                </td>
                              </tr>
                            </thead>
                          </table>
                        </Col>
                        <Col span={12}>
                          <table>
                            <thead>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bolder",
                                  }}
                                >
                                  Time
                                </td>
                                <td>:</td>
                                <td
                                  style={{
                                    textAlign: "left",
                                    paddingLeft: ".5rem",
                                  }}
                                >
                                  {data.createdAt &&
                                    moment.utc(data.createdAt).utcOffset("+05:30").format("hh:mm A")}
                                </td>
                              </tr>
                            </thead>
                          </table>
                        </Col>
                      </Row>
                      <div
                        style={{
                          border: "0.1px solid rgba(0, 0, 0, 0.3)",
                          borderRadius: ".2rem",
                          margin: "1rem",
                          padding: "0.4rem 0.5rem",
                        }}
                      >
                        <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                          <h1 style={{ textAlign: "center", margin: 0, fontSize: "20px" }}>
                            Status :{data.jobStatus && data.jobStatus}
                          </h1>
                          {((data.jobStatus === "Work In Progress" && data.hasPartsIssued) ||
                            (data.jobStatus === "Mechanic Allocated" &&
                              (data.previousStatus === "Parts Issued" || data.hasPartsIssued))) && (
                            <Tag color="cyan" style={{ fontSize: "13px", fontWeight: "600", padding: "2px 8px", borderRadius: "4px" }}>
                              Parts Issued
                            </Tag>
                          )}
                          {((data.jobStatus === "Work In Progress" && data.hasLabourPerformed) ||
                            (data.jobStatus === "Mechanic Allocated" &&
                              (data.previousStatus === "Labour Performed" || data.hasLabourPerformed)) ||
                            data.jobStatus === "Labour Performed") && (
                            <Tag
                              color="purple"
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                padding: "2px 8px",
                                borderRadius: "4px",
                                cursor:
                                  labourPerformReadAccess && data.labourPerformId
                                    ? "pointer"
                                    : "default",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  labourPerformReadAccess &&
                                  data.labourPerformId
                                ) {
                                  history.push(
                                    `/autoadmin/labour_perform/${data.labourPerformId}`
                                  );
                                }
                              }}
                            >
                              Labour Performed
                            </Tag>
                          )}
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {/* Full-width action toolbar — wraps evenly, no overflow/overlap */}
            <div
              className="jobcard-action-toolbar"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "8px",
                width: "100%",
                boxSizing: "border-box",
                padding: "8px 12px 16px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {data.serviceType &&
                data.serviceType.toLowerCase().includes("accidental") &&
                !["Work Completed", "Ready for Delivery", "Feedback Call", "Closed"].includes(
                  data.jobStatus
                ) && (
                  <Button
                    type="primary"
                    ghost
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedJobForClaim(data);
                      setClaimModalOpen(true);
                    }}
                  >
                    Claim Intimation
                  </Button>
                )}
              {estimateAccess &&
                !props.isCompletedTab &&
                props.tab !== "Work Completed" &&
                ![
                  "Work Completed",
                  "Washing",
                  "Washing and Final Inspection",
                  "Final Inspection",
                  "Proforma Invoice",
                  "Payment Completed",
                  "Ready for Delivery",
                  "Feedback Call",
                  "Closed",
                ].includes(data.jobStatus) && (
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      const estimate =
                        data.Estimate && data.Estimate.length > 0
                          ? data.Estimate[0]
                          : null;
                      if (estimate) {
                        history.push({
                          pathname: `/autoadmin/estimate/${estimate.id}?edit=true`,
                          state: { jobNo: data.id, gst: gst },
                        });
                      } else {
                        history.push({
                          pathname: "/autoadmin/estimate/:id",
                          state: { jobNo: data.id, gst: gst },
                        });
                      }
                    }}
                  >
                    Estimate
                  </Button>
                )}
              {whatsappAccess && (
                <Button
                  onClick={(event) => {
                    event.stopPropagation();
                    sendSms(data, "WhatsApp");
                  }}
                >
                  Send WhatsApp
                </Button>
              )}
              {callAccess && (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCall(data);
                  }}
                >
                  Call Customer
                </Button>
              )}
              {["Work In Progress", "Parts Issued", "Labour Performed"].includes(
                data.jobStatus
              ) &&
                materialIssueAccess && (
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      history.push({
                        pathname: "/autoadmin/material_issue/:id",
                        state: { jobNo: data.id },
                      });
                    }}
                  >
                    Parts Issue
                  </Button>
                )}
              {["Work In Progress", "Parts Issued", "Labour Performed"].includes(
                data.jobStatus
              ) &&
                labourPerformAccess && (
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      if (data.hasLabourPerformed && data.labourPerformId) {
                        history.push(
                          `/autoadmin/labour_perform/${data.labourPerformId}`
                        );
                      } else {
                        history.push({
                          pathname: "/autoadmin/labour_perform/:id",
                          state: { jobNo: data.id },
                        });
                      }
                    }}
                  >
                    Labour Perform
                  </Button>
                )}
              {estimateAccess && data.jobStatus == "Estimation" && (
                <Button
                  onClick={(event) => {
                    event.stopPropagation();
                    sendEstOtp(data);
                    setOtpData(data.id);
                  }}
                >
                  Approve Estimate OTP
                </Button>
              )}
              {modify &&
                !props.isCompletedTab &&
                props.tab !== "Work Completed" &&
                ![
                  "Work Completed",
                  "Washing",
                  "Washing and Final Inspection",
                  "Final Inspection",
                  "Proforma Invoice",
                  "Payment Completed",
                  "Ready for Delivery",
                  "Feedback Call",
                  "Closed",
                ].includes(data.jobStatus) &&
                (data.jobStatus === "Estimation Approved" ||
                  data.jobStatus === "Mechanic Allocated" ||
                  data.jobStatus === "Vehicle Received" ||
                  data.jobStatus === "Estimation" ||
                  data.jobStatus === "Claim Intimated" ||
                  data.jobStatus === "Surveyor Appointed" ||
                  data.jobStatus === "Spares Ordered" ||
                  data.jobStatus === "Spares Partially" ||
                  data.jobStatus === "Spare Received" ||
                  data.jobStatus === "Spares Received" ||
                  checkStatus(data.jobStatus) === "1") && (
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      setAssignData(data.id);
                      setAssign(true);
                    }}
                  >
                    {data.mechanic ? "ReAssign Mechanic" : "Assign Mechanic"}
                  </Button>
                )}
              {spareAccess &&
                !props.isCompletedTab &&
                props.tab !== "Work Completed" &&
                ![
                  "Work Completed",
                  "Washing",
                  "Washing and Final Inspection",
                  "Final Inspection",
                  "Proforma Invoice",
                  "Payment Completed",
                  "Ready for Delivery",
                  "Feedback Call",
                  "Closed",
                ].includes(data.jobStatus) &&
                ([
                  "Vehicle Received",
                  "Claim Intimated",
                  "Surveyor Appointed",
                  "Estimation",
                  "Estimation Approved",
                  "Mechanic Allocated",
                  "Spares Ordered",
                  "Spares Partially Ordered",
                  "Spare Received",
                  "Work In Progress",
                  "Parts Issued",
                  "Labour Performed",
                ].includes(data.jobStatus) ||
                  (checkStatus(data.jobStatus) === "1" &&
                    data.jobStatus !== "Material Issued")) && (
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      history.push({
                        pathname: "/autoadmin/customerspare/:id",
                        state: {
                          jobCard: {
                            jobNo: data.jobNo,
                            jobId: data.id,
                            orderType: "JOB_CARD",
                            editable: true,
                          },
                        },
                      });
                    }}
                  >
                    Order Spares
                  </Button>
                )}
              {!props.isMechanic &&
                loginCredintials?.role !== "Mechanic" &&
                data.mechanic &&
                !data.timerRunning &&
                (data.jobStatus === "Mechanic Allocated" ||
                  // After non-mech Stop: previous section with elapsed time
                  (data.elapsedSeconds > 0 &&
                    [
                      "Vehicle Received",
                      "Claim Intimated",
                      "Surveyor Appointed",
                      "Estimation",
                      "Estimation Approved",
                      "Spares Ordered",
                      "Spares Partially Ordered",
                      "Spare Received",
                      "Spares Received",
                    ].includes(data.jobStatus)) ||
                  // After Redo / mechanic Pause: WIP-active, timer stopped
                  [
                    "Work In Progress",
                    "Parts Issued",
                    "Labour Performed",
                    "Material Issued",
                  ].includes(data.jobStatus)) && (
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#10b981",
                      borderColor: "#10b981",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleStartWork(data.id);
                    }}
                  >
                    Start Work
                  </Button>
                )}
              {props.tab !== "Feedback Call" &&
                ![
                  "Delivered",
                  "Feedback Call",
                  "Closed",
                  "PAID",
                  "Payment Received",
                ].includes(data.jobStatus) &&
                (props.tab === "Work Completed" ||
                  props.tab === "Ready for Delivery" ||
                  [
                    "Final Inspection",
                    "Washing",
                    "Washing and Final Inspection",
                    "Proforma Invoice",
                    "Payment Completed",
                    "Ready for Delivery",
                  ].includes(data.jobStatus)) && (
                  <Button
                    type="primary"
                    ghost={data.jobStatus !== "Final Inspection"}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedJobForInspection(data);
                      setFinalInspectionModalOpen(true);
                    }}
                  >
                    Final Inspection
                  </Button>
                )}
              {(["Washing", "Washing and Final Inspection"].includes(
                data.jobStatus
              ) ||
                data.jobInvoiceId) && (() => {
                const invoicePaid = ["PAID", "FEEDBACK_COMPLETED"].includes(
                  data.jobInvoiceStatus
                );
                const isViewInvoice = Boolean(data.jobInvoiceId && invoicePaid);
                return (
                <Button
                  type="primary"
                  ghost={isViewInvoice}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!data.jobInvoiceId) {
                      history.push({
                        pathname: "/autoadmin/job_invoice/:id",
                        state: {
                          jobNo: data.id,
                          prefillFromIssue: true,
                          gst,
                        },
                      });
                      return;
                    }
                    history.push({
                      pathname: `/autoadmin/job_invoice/${data.jobInvoiceId}`,
                      state: invoicePaid
                        ? { gst }
                        : { gst, editable: true },
                    });
                  }}
                >
                  {!data.jobInvoiceId
                    ? "Create Invoice"
                    : isViewInvoice
                      ? "View Invoice"
                      : "Invoice"}
                </Button>
                );
              })()}
              {(props.tab === "Ready for Delivery" ||
                ["Payment Completed", "Ready for Delivery"].includes(
                  data.jobStatus
                )) && (
                <Button
                  type="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedJobForGatePass(data);
                    setGatePassModalOpen(true);
                  }}
                >
                  Gate Pass OTP
                </Button>
              )}
            </div>

            <Row style={{ display: "flex", justifyContent: "center", padding: "8px 12px 4px" }}>
              <Col span={24}>
                <Steps
                  progressDot
                  current={parseInt(checkStatus(data.jobStatus))}
                >
                  <Step
                    key="pending"
                    title="Pending"
                    description={
                      checkStatus(data.jobStatus) == "0"
                        ? data.jobStatus && data.jobStatus
                        : ""
                    }
                  />
                  <Step
                    key="progress"
                    title="In Progress"
                    description={
                      checkStatus(data.jobStatus) === "1"
                        ? data.jobStatus && data.jobStatus
                        : ""
                    }
                  />
                  <Step
                    key="completed"
                    title="Completed"
                  />
                </Steps>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginRight: ".5rem",
                marginTop: "8px",
              }}
            >
              <div>
                {(data.jobStatus === "Work In Progress" ||
                  (data.jobStatus === "Parts Issued" && (data.timerRunning || (data.elapsedSeconds && data.elapsedSeconds > 0))) ||
                  (data.jobStatus === "Mechanic Allocated" && data.elapsedSeconds > 0) ||
                  data.jobStatus === "Work Completed" ||
                  data.jobStatus === "Final Inspection" ||
                  data.jobStatus === "Washing" ||
                  data.jobStatus === "Washing and Final Inspection" ||
                  data.jobStatus === "Proforma Invoice" ||
                  props.isCompletedTab ||
                  props.tab === "Work Completed") && (
                    <WorkInProgress
                      jobCard={data}
                      currentUser={loginCredintials}
                      isMechanic={false}
                      isCompleted={
                        data.jobStatus !== "Work In Progress" &&
                        data.jobStatus !== "Parts Issued"
                      }
                      onWorkStatusChange={() => {
                        if (props.setPageData) props.setPageData(null, props.tab);
                        else if (props.onPageChange) props.onPageChange(props.page || 1);
                      }}
                    />
                  )}
              </div>
              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                {data.serviceType !== "PDI" && (
                  <>
                    <span
                      className="linkylink"
                      onClick={(event) => {
                        event.stopPropagation();
                        console.log('Complete Job Card Data:', data);
                        handlePushToPymidol(data.id);
                      }}
                      style={{ opacity: pymidolLoading[data.id] ? 0.6 : 1 }}
                    >
                      {pymidolLoading[data.id] ? 'Pushing...' : 'Push to Pymidol'}
                    </span>
                    <Divider type="vertical" />
                  </>
                )}
                <>
                  <span
                    className="linkylink"
                    onClick={(event) => {
                      event.stopPropagation();
                      resendJobCardSms(data);
                    }}
                    style={{
                      opacity: resendSmsLoading[data.id] ? 0.6 : 1,
                      pointerEvents: resendSmsLoading[data.id] ? 'none' : 'auto',
                    }}
                  >
                    {resendSmsLoading[data.id] ? 'Sending...' : 'Resend WhatsApp'}
                  </span>
                  <Divider type="vertical" />
                </>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/job_status/${data.id}?edit=true`}
                  className="linkylink"
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  Tracking URL
                </a>
                {
                  hasCashCollectAccess() && !props.isCompletedTab && (
                    <>
                      <Divider type="vertical" />
                      <span
                        className="linkylink"
                        onClick={(event) => {
                          event.stopPropagation();
                          setSelectedData(data);
                          setPaymentModal(true);
                        }}
                      >
                        Collect Cash
                      </span>
                    </>
                  )
                }
                <Divider type="vertical" />
                {
                  spareAccess && (data.jobStatus === "Spares Ordered" || data.jobStatus === "Spare Received" || data.jobStatus === "Spares Partially Ordered") &&
                  <><span
                    onClick={(event) => {
                      event.stopPropagation();
                      setSelectedid(data.id);
                      setOrderspareModal(true);
                    }}
                    className="linkylink"
                  >
                    Track Ordered spares
                  </span>
                    <Divider type="vertical" /></>
                }
                {modify && <span
                  onClick={(event) => {
                    event.stopPropagation();
                    setLogData(data.id);
                    setLog(true);
                  }}
                  className="linkylink"
                >
                  Logs
                </span>}
                <Divider type="vertical" />
                {modify && !props.isCompletedTab ? (
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      openModal(data.id && data.id, true, true);
                    }}
                    className="linkylink"
                  >
                    Modify
                    <Divider type="vertical" />
                  </span>
                ) : (
                  <span></span>
                )}
                {printAccess ? (
                  <>
                    <span
                      className="linkylink"
                      onClick={(event) => handleDownloadPDF(data, event)}
                    >
                      Download PDF
                    </span>
                    <Divider type="vertical" />
                    <span
                      className="linkylink"
                      onClick={(event) => handleDownloadAdditionalSheets(data, event)}
                    >
                      Additional Sheets
                    </span>
                  </>
                ) : (
                  <span></span>
                )}
                <Divider type="vertical" />
                {callAccess && data.jobStatus == "PAID" && !data.customerFeedback ? (
                  <>
                    <span
                      className="linkylink"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedData({ ...data, view: false });
                        setFeedbackCallOpen(true);
                      }}
                    >
                      Feedback Call
                    </span>
                    <Divider type="vertical" />
                  </>
                ) : modify && data.jobStatus == "PAID" && data.customerFeedback ?
                  <>
                    <span
                      className="linkylink"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedData({ ...data, view: true });
                        setFeedbackCallOpen(true);
                      }}
                    >
                      View Feedback
                    </span>
                    <Divider type="vertical" />
                  </>
                  : (
                    <span></span>
                  )}
                {deleteAccess && !props.isCompletedTab ? (
                  <Popconfirm
                    title="Do you want to delete this Job Order?"
                    okText="Yes"
                    cancelText="No"
                    onCancel={(event) => {
                      event.stopPropagation();
                    }}
                    onConfirm={(event) => {
                      event.stopPropagation();
                      props.delete(data.id && data.id);
                    }}
                  >
                    <span
                      onClick={(event) => event.stopPropagation()}
                      className="linkylink"
                    >
                      Delete
                    </span>
                  </Popconfirm>
                ) : (
                  <span></span>
                )}
                {!modify && !deleteAccess && !printAccess ? (
                  <Text strong disabled>
                    No Actions Given
                  </Text>
                ) : (
                  <span></span>
                )}
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div id="jobOrder">
      <Table
        rowKey={(record, index) => record.id || index}
        pagination={pagination}
        columns={column}
        tableLayout="auto"
        style={{ cursor: "pointer" }}
        dataSource={dataSource}
        onRow={(props) => ({
          onClick: () => openModal(props.id, false),
        })}
        loading={spinner}
      />

      {orderspareModal &&
        <TrackSpareOrderModal
          open={orderspareModal}
          close={() => { setOrderspareModal(false) }}
          jobId={selectedid}
        />
      }

      {feedbackCallOpen &&
        <WrappedFeedbackCallModal
          open={feedbackCallOpen}
          close={() => setFeedbackCallOpen(false)}
          data={selectedData}
        />
      }

      {paymentModal &&
        <PaymentModal
          visible={paymentModal}
          onClose={() => {
            setPaymentModal(false);
            setSelectedData(null);
          }}
          data={selectedData}
          module={"JobOrder"}
          moduleId={selectedData.id}
          branchId={selectedData.branch.id}

        />
      }

      {customerLedgerOpen && selectedCustomer && (
        <LedgerModal
          visible={customerLedgerOpen}
          onCancel={() => {
            setCustomerLedgerOpen(false);
            setSelectedCustomer(null);
          }}
          data={selectedCustomer}
          type="CUSTOMERS"
          initialSubTab="JobOrder"
        />
      )}

      {claimModalOpen && selectedJobForClaim && (
        <ClaimIntimationModal
          open={claimModalOpen}
          onCancel={() => {
            setClaimModalOpen(false);
            setSelectedJobForClaim(null);
          }}
          jobOrder={selectedJobForClaim}
          onSuccess={(targetTab) => {
            if (props.onTabSwitch) {
              props.onTabSwitch(targetTab || "2");
            } else if (props.setPageData) {
              props.setPageData();
            }
          }}
        />
      )}

      {finalInspectionModalOpen && selectedJobForInspection && (
        <FinalInspectionModal
          open={finalInspectionModalOpen}
          onCancel={() => {
            setFinalInspectionModalOpen(false);
            setSelectedJobForInspection(null);
          }}
          jobOrder={{
            ...selectedJobForInspection,
            jobStatus: selectedJobForInspection.jobStatus || selectedJobForInspection.status,
          }}
          readOnly={
            props.tab === "Ready for Delivery" ||
            ["Payment Completed", "Ready for Delivery"].includes(
              selectedJobForInspection?.jobStatus || selectedJobForInspection?.status
            )
          }
          onSuccess={(newStatus) => {
            if (newStatus === "Work In Progress") {
              if (props.onTabSwitch) {
                props.onTabSwitch("4");
              } else if (props.setPageData) {
                props.setPageData(null, "Work In Progress");
              }
              return;
            }
            if (props.setPageData) {
              props.setPageData(null, props.tab || "Work Completed");
            } else if (props.onPageChange) {
              props.onPageChange(props.page || 1);
            }
          }}
        />
      )}

      {gatePassModalOpen && selectedJobForGatePass && (
        <GatePassOtpModal
          open={gatePassModalOpen}
          onCancel={() => {
            setGatePassModalOpen(false);
            setSelectedJobForGatePass(null);
          }}
          jobOrder={selectedJobForGatePass}
        />
      )}

      {sectionsModalOpen && selectedJobForSections && (
        <JobCardSectionsModal
          open={sectionsModalOpen}
          onCancel={() => {
            setSectionsModalOpen(false);
            setSelectedJobForSections(null);
          }}
          jobCard={selectedJobForSections}
          currentUser={loginCredintials}
          onAssignMechanic={() => {
            setSectionsModalOpen(false);
            setAssign(true);
            setAssignData(selectedJobForSections);
          }}
          onOpenClaimIntimation={() => {
            setSelectedJobForClaim(selectedJobForSections);
            setClaimModalOpen(true);
          }}
          onOpenEstimate={() => {
            const estimate = selectedJobForSections.Estimate && selectedJobForSections.Estimate.length > 0 ? selectedJobForSections.Estimate[0] : null;
            if (estimate) {
              history.push({
                pathname: `/autoadmin/estimate/${estimate.id}?edit=true`,
                state: { jobNo: selectedJobForSections.id, gst: gst },
              });
            } else {
              history.push({
                pathname: "/autoadmin/estimate/:id",
                state: { jobNo: selectedJobForSections.id, gst: gst },
              });
            }
          }}
          onOpenSparesOrder={() => {
            setSelectedid(selectedJobForSections.id);
            setOrderspareModal(true);
          }}
          onStartWork={() => {
            handleStartWork(selectedJobForSections.id);
            setSectionsModalOpen(false);
          }}
          onWorkStatusChange={() => {
            if (props.onPageChange) props.onPageChange(props.page || 1);
          }}
        />
      )}
    </div>
  );
};

export default JobOrderTable;
